/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CombinedGoodsListForPackBaseGoodsForPackVo } from './CombinedGoodsListForPackBaseGoodsForPackVo';
import {
    CombinedGoodsListForPackBaseGoodsForPackVoFromJSON,
    CombinedGoodsListForPackBaseGoodsForPackVoFromJSONTyped,
    CombinedGoodsListForPackBaseGoodsForPackVoToJSON,
    CombinedGoodsListForPackBaseGoodsForPackVoToJSONTyped,
} from './CombinedGoodsListForPackBaseGoodsForPackVo';

/**
 * 
 * @export
 * @interface CombinedGoodsListForPackCombinedGoodsForPackVo
 */
export interface CombinedGoodsListForPackCombinedGoodsForPackVo {
    /**
     * 商品id
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    id?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    code?: string;
    /**
     * 商品数量
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    quantity?: number;
    /**
     * 装箱数量
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    packagedQuantity?: number;
    /**
     * 商品选项名称
     * @type {string}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    marketOptionName?: string;
    /**
     * 商品选项ID
     * @type {string}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    marketOptionId?: string;
    /**
     * 商品入库条码
     * @type {string}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    marketBarcode?: string;
    /**
     * 商品重量 kg
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    weight?: number;
    /**
     * 商品长度
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    length?: number;
    /**
     * 商品宽度
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    width?: number;
    /**
     * 商品高度
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    height?: number;
    /**
     * 商品CBM
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    cbm?: number;
    /**
     * 商品单独包装费用
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    individuallyPackagedFee?: number;
    /**
     * 商品合包包装费用
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    combinedPackagedFee?: number;
    /**
     * 贴条码费用
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    barcodeFee?: number;
    /**
     * 原产地标费用
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    originMarkFee?: number;
    /**
     * 使用opp袋费用
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    oppFee?: number;
    /**
     * 使用快递袋费用
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    courierBagFee?: number;
    /**
     * 商品是否可以原包装出库
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    originPackageOutbound?: number;
    /**
     * 商品来源
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    sourceType?: number;
    /**
     * sku id
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    skuId?: number;
    /**
     * sku编码
     * @type {string}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    skuCode?: string;
    /**
     * 是否打印原产地
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    originPrint?: number;
    /**
     * 是否样品商品 0 不是 1 是
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    simple?: number;
    /**
     * 是否有样品商品 0 没有 1 有
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    hasSimpleGoods?: number;
    /**
     * 样品商品数量
     * @type {number}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    simpleGoodsNumber?: number;
    /**
     * 合包商品下的基础商品列表
     * @type {Array<CombinedGoodsListForPackBaseGoodsForPackVo>}
     * @memberof CombinedGoodsListForPackCombinedGoodsForPackVo
     */
    baseGoodsForPackVOList?: Array<CombinedGoodsListForPackBaseGoodsForPackVo>;
}

/**
 * Check if a given object implements the CombinedGoodsListForPackCombinedGoodsForPackVo interface.
 */
export function instanceOfCombinedGoodsListForPackCombinedGoodsForPackVo(value: object): value is CombinedGoodsListForPackCombinedGoodsForPackVo {
    return true;
}

export function CombinedGoodsListForPackCombinedGoodsForPackVoFromJSON(json: any): CombinedGoodsListForPackCombinedGoodsForPackVo {
    return CombinedGoodsListForPackCombinedGoodsForPackVoFromJSONTyped(json, false);
}

export function CombinedGoodsListForPackCombinedGoodsForPackVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombinedGoodsListForPackCombinedGoodsForPackVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'packagedQuantity': json['packagedQuantity'] == null ? undefined : json['packagedQuantity'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'individuallyPackagedFee': json['individuallyPackagedFee'] == null ? undefined : json['individuallyPackagedFee'],
        'combinedPackagedFee': json['combinedPackagedFee'] == null ? undefined : json['combinedPackagedFee'],
        'barcodeFee': json['barcodeFee'] == null ? undefined : json['barcodeFee'],
        'originMarkFee': json['originMarkFee'] == null ? undefined : json['originMarkFee'],
        'oppFee': json['oppFee'] == null ? undefined : json['oppFee'],
        'courierBagFee': json['courierBagFee'] == null ? undefined : json['courierBagFee'],
        'originPackageOutbound': json['originPackageOutbound'] == null ? undefined : json['originPackageOutbound'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'originPrint': json['originPrint'] == null ? undefined : json['originPrint'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'hasSimpleGoods': json['hasSimpleGoods'] == null ? undefined : json['hasSimpleGoods'],
        'simpleGoodsNumber': json['simpleGoodsNumber'] == null ? undefined : json['simpleGoodsNumber'],
        'baseGoodsForPackVOList': json['baseGoodsForPackVOList'] == null ? undefined : ((json['baseGoodsForPackVOList'] as Array<any>).map(CombinedGoodsListForPackBaseGoodsForPackVoFromJSON)),
    };
}

export function CombinedGoodsListForPackCombinedGoodsForPackVoToJSON(json: any): CombinedGoodsListForPackCombinedGoodsForPackVo {
    return CombinedGoodsListForPackCombinedGoodsForPackVoToJSONTyped(json, false);
}

export function CombinedGoodsListForPackCombinedGoodsForPackVoToJSONTyped(value?: CombinedGoodsListForPackCombinedGoodsForPackVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'quantity': value['quantity'],
        'packagedQuantity': value['packagedQuantity'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'marketBarcode': value['marketBarcode'],
        'weight': value['weight'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'cbm': value['cbm'],
        'individuallyPackagedFee': value['individuallyPackagedFee'],
        'combinedPackagedFee': value['combinedPackagedFee'],
        'barcodeFee': value['barcodeFee'],
        'originMarkFee': value['originMarkFee'],
        'oppFee': value['oppFee'],
        'courierBagFee': value['courierBagFee'],
        'originPackageOutbound': value['originPackageOutbound'],
        'sourceType': value['sourceType'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'originPrint': value['originPrint'],
        'simple': value['simple'],
        'hasSimpleGoods': value['hasSimpleGoods'],
        'simpleGoodsNumber': value['simpleGoodsNumber'],
        'baseGoodsForPackVOList': value['baseGoodsForPackVOList'] == null ? undefined : ((value['baseGoodsForPackVOList'] as Array<any>).map(CombinedGoodsListForPackBaseGoodsForPackVoToJSON)),
    };
}

